import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";

const state = {
  superSpaces: [],
  superSpace: null,

  superSpacesAvailablePage: 1,
  lastPageSuperSpaces: 2,
};
export type State = typeof state;

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
